import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import useDeleteHook from "../../customHooks/useDeleteHook";
import { tw } from "@careinfo/tailwind";

const JournalEntryComponent = loadable(
  () => import("../../components/JournalEntry/List")
);

export default () => {
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["journal-entry"],
  });

  const handleDelete = async (id: string, setOpenDeletePopup: any) => {
    const url = `${APIS.BILL}${id}/`;
    const formData = {};
    try {
      const res = await mutateAsync({ url, formData, setError: () => {} });
      if (res?.status === 204) {
        setOpenDeletePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div>
      <div className={tw`flex items-center justify-between mb-2`}>
        <h1 className={tw`font-semibold text-2xl leading-8`}>
          Journal Voucher
        </h1>
      </div>
      <JournalEntryComponent
        handleDelete={handleDelete}
        isLoading={isLoading}
      />
    </div>
  );
};
